<template>
    <v-dialog v-model="dialog" width="500" persistent>
        <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="d-inline">
                <slot></slot>
            </div>
        </template>
        <v-card>
            <v-card-title class="flex-nowrap align-start">
                {{ title }}
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false" icon><v-icon>clear</v-icon></v-btn>
            </v-card-title>
            <v-card-subtitle>{{ limit.start_date }} - {{ limit.end_date }}</v-card-subtitle>
            <v-card-text>
                <p>{{ text }}</p>
                <v-form v-model="valid" ref="form" @submit.prevent="valid ? confirm() : null">
                    <v-text-field
                        v-model="check"
                        :rules="[rules.required, rules.year]"
                        prepend-icon="mdi-lock-open-variant-outline"
                        outlined
                        dense
                        label="Start year"></v-text-field>
                </v-form>
                <v-alert type="error" text v-if="error">{{ error }}</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="error" v-if="!success" :loading="deleting" :disabled="!valid" @click="confirm()">Confirm</v-btn>
                <v-btn color="success" v-if="success"><v-icon>mdi-check</v-icon></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ConfirmDeleteDialog',
    components: {},
    props: {
        limit: Object,
        limitType: {
            type: String,
            default: 'ncu' // 'ncu', 'fs', 'resting'
        }
    },
    data() {
        return {
            dialog: false,
            check: '',
            valid: true,
            rules: {
                required: value => !!value || 'This field is required',
                year: value => {
                    const startYear = new Date(this.limit.start_date).getFullYear()
                    return Number(value) === startYear || `Please enter the year to confirm deletion.`
                }
            },
            deleting: false,
            success: false,
            error: null
        }
    },
    computed: {
        title() {
            let typeLabel = ''
            switch (this.limitType) {
                case 'ncu':
                    typeLabel = 'NCU'
                    break
                case 'fs':
                    typeLabel = 'File System'
                    break
                case 'resting':
                    typeLabel = 'Resting storage'
                    break
                default:
                    typeLabel = ''
            }
            return `Confirm deleting ${typeLabel} limit`
        },
        text() {
            let typeLabel = ''
            switch (this.limitType) {
                case 'ncu':
                    typeLabel = 'NCU'
                    break
                case 'fs':
                    typeLabel = 'File System'
                    break
                case 'resting':
                    typeLabel = 'Resting storage'
                    break
                default:
                    typeLabel = ''
            }
            return `To confirm, please enter the year from the ${typeLabel} limit's start date.`
        }
    },
    methods: {
        async confirm() {
            this.error = null
            this.deleting = true
            try {
                let endpoint = `/resource/${this.$route.params.rpid}`
                switch (this.limitType) {
                    case 'ncu':
                        endpoint += `/ncul/${this.limit.nlid}`
                        break
                    case 'fs':
                        endpoint += `/fsl/${this.limit.fslid}`
                        break
                    case 'resting':
                        endpoint += `/rsl/${this.limit.rslid}`
                        break
                    default:
                        throw new Error('Unknown limit type')
                }
                await this.$axios.delete(endpoint)
                this.success = true
                this.$emit('success')
                setTimeout(() => {
                    this.dialog = false
                }, 2000)
            } catch (error) {
                this.error = error.message || 'An error occurred while processing your request.'
            }
            this.deleting = false
        }
    },
    watch: {
        dialog(open) {
            if (open) {
                this.check = ''
                this.valid = true
                this.success = false
                this.error = null
                this.$refs.form.resetValidation()
            }
        }
    },
    mounted() {}
}
</script>
